angular.module('leanlaw').controller('AttorneyRevenueUnallocatedCtrl', ['$scope', '$rootScope', '$q', '$filter', '$state', '$stateParams', "alerts", 'userService', 'reportsService', 'singleRequest', 'accountingService', "exportJson", "messageBus", function ($scope, $rootScope, $q, $filter, $state, $stateParams, alerts, userService, reportsService, singleRequest, accountingService, exportJson, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filtered.reduce((accum, c) => {
      let item = {};
      if ($scope.clientReferences || $scope.references) {
        if ($scope.filter.include && $scope.filter.include.matters) {
          item = {
            "ID": c.client.reference || "",
            "Client": c.client.name,
            [matter]: "",
            "Expenses (Billed)": $filter("amount")(c.data.billed.expensesUnassigned),
            "Fixed Fees (Billed)": $filter("amount")(c.data.billed.servicesUnassigned),
            "Expenses (Collected)": $filter("amount")(c.data.collected.expensesUnassigned),
            "Fixed Fees (Collected)": $filter("amount")(c.data.collected.servicesUnassigned),
            "Non-LeanLaw (Collected)": $filter("amount")(c.data.collected.other)
          };
        } else {
          item = {
            "ID": c.client.reference || "",
            "Client": c.client.name,
            "Expenses (Billed)": $filter("amount")(c.data.billed.expensesUnassigned),
            "Fixed Fees (Billed)": $filter("amount")(c.data.billed.servicesUnassigned),
            "Expenses (Collected)": $filter("amount")(c.data.collected.expensesUnassigned),
            "Fixed Fees (Collected)": $filter("amount")(c.data.collected.servicesUnassigned),
            "Non-LeanLaw (Collected)": $filter("amount")(c.data.collected.nonLeanLaw)
          };
        }
      } else if ($scope.filter.include && $scope.filter.include.matters) {
        item = {
          "ID": c.client.reference || "",
          "Client": c.client.name,
          [matter]: "",
          "Expenses (Billed)": $filter("amount")(c.data.billed.expensesUnassigned),
          "Fixed Fees (Billed)": $filter("amount")(c.data.billed.servicesUnassigned),
          "Expenses (Collected)": $filter("amount")(c.data.collected.expensesUnassigned),
          "Fixed Fees (Collected)": $filter("amount")(c.data.collected.servicesUnassigned),
          "Non-LeanLaw (Collected)": $filter("amount")(c.data.collected.nonLeanLaw)
        };
      } else {
        item = {
          "Client": c.client.name,
          "Expenses (Billed)": $filter("amount")(c.data.billed.expensesUnassigned),
          "Fixed Fees (Billed)": $filter("amount")(c.data.billed.servicesUnassigned),
          "Expenses (Collected)": $filter("amount")(c.data.collected.expensesUnassigned),
          "Fixed Fees (Collected)": $filter("amount")(c.data.collected.servicesUnassigned),
          "Non-LeanLaw (Collected)": $filter("amount")(c.data.collected.nonLeanLaw)
        };
      }
      accum.push(item);
      if ($scope.filter.include && $scope.filter.include.matters) {
        c.matters.forEach(m => {
          let item = {
            "ID": m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '',
            "Client": "",
            [matter]: m.matter.name,
            "Expenses (Billed)": $filter("amount")(m.data.billed.expensesUnassigned),
            "Fixed Fees (Billed)": $filter("amount")(m.data.billed.servicesUnassigned),
            "Expenses (Collected)": $filter("amount")(m.data.collected.expensesUnassigned),
            "Fixed Fees (Collected)": $filter("amount")(m.data.collected.servicesUnassigned),
            "Non-LeanLaw (Collected)": $filter("amount")(m.data.collected.nonLeanLaw)
          };
          accum.push(item);
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  activate();

  ///////////////////////////////////////

  function activate() {
    userService.me().then(me => {
      $scope.me = me;
      accountingService.verify(false).then(status => {
        $scope.accounting = status.connected;
        $scope.$on('commonFilterService-statechanged', (event, payload) => {
          if (!payload) return;
          // Assigning to existing filter keeps custom filter options
          $scope.filter = Object.assign($scope.filter, payload);
          // Necessary to set this value for the requests
          $scope.filter.status = $scope.filter.archived.status;
          $scope.filter.scope = $scope.filter.filter.scope;
          if (payload.filter.range) {
            filterClientEntries();
          }
        });
        $scope.$on("report-sidebar-filterchange", (event, payload) => {
          $scope.filter = Object.assign($scope.filter, payload);
        });

        // MessageBus is used here so that the commonFilter module can pick it up once it loads
        messageBus.addMessage("filterDependency-ready", true);
      });
    });
  }
  let _cancelReport = null;
  function filterClientEntries() {
    if (_cancelReport) {
      _cancelReport.resolve("reloading");
    }
    _cancelReport = $q.defer();
    var query = reportsService.queryFromFilter($scope.filter);
    query.data = "invoices";
    if ($scope.accounting) {
      query.data += ",payments";
    }
    query.account = 'none';
    query.billed = 'any';
    query.billedState = undefined;
    query.billingType = '-internal';
    query.primary = 'clients';
    query.zeros = false;
    query.$timeout = _cancelReport.promise;
    $scope.loading = true;
    singleRequest.apiCall("report").getReport(query).then(data => {
      if (!data) return; // happens if we were canceled
      $scope.loading = false;
      $scope.data = data;
      $scope.references = data.clients.some(c => c.matters.some(m => m.matter.reference));
      $scope.clientReferences = data.clients.some(c => c.client.reference);
      $scope.other = !!data.data.collected.nonLeanLaw;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("report");
    deactivate();
  });
  $scope.$watch("loading", newValue => console.log("l", newValue));

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filtered = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filtered.forEach(client => {
      client.filteredMatters = $filter('orderBy')($filter('filter')(client.matters, $scope.q), $scope.sort, $scope.reverse) || [];
    });
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);